import {
    GET_REPORTS_DASHBOARD_COUNTS,
    GET_REPORTS_DASHBOARD_COUNTS_PENDING,
    GET_REPORTS_DASHBOARD_COUNTS_FULFILLED,
    GET_REPORTS_DASHBOARD_COUNTS_REJECTED,

    GET_REPORTS_PROGRAMS_COUNTS_PENDING,
    GET_REPORTS_PROGRAMS_COUNTS_FULFILLED,
    GET_REPORTS_PROGRAMS_COUNTS_REJECTED,
} from '../../actions/action-constants';

const initialState = {
    loading: true,
    errors: [],
    error: '',

    reportTitle: "Title Unknown",

    referrals: -1,
    clients: -1,
    postdischarges: -1,

    postdischarges90d: -1,
    postdischarges180d: -1,
    postdischarges12m: -1,
    postdischarges24m: -1,
    postdischarges36m: -1,

    archivedreferrals: -1,
    archivedclients: -1,
    archivedpostdischarges: -1,

    reportData: [],

};

const reducerReportsGlobals = (state = initialState, action) => {
                                            // console.log("4447-10003 - reducerReportsGlobals - action.type = " + action.type);
//   var dataEntry;
  switch (action.type) {
    case GET_REPORTS_DASHBOARD_COUNTS_PENDING:
    case GET_REPORTS_PROGRAMS_COUNTS_PENDING:
        state = {
            ...state,
            loadingList: true
        };
        break;
    case GET_REPORTS_DASHBOARD_COUNTS:
    case GET_REPORTS_DASHBOARD_COUNTS_FULFILLED:
        var dataEntry;

        var referrals = -1;
        var clients = -1;
        var postdischarges = -1;
        
        var postdischarges90d = -1;
        var postdischarges180d = -1;
        var postdischarges12m = -1;
        var postdischarges24m = -1;
        var postdischarges36m = -1;
    
        var archivedreferrals = -1;
        var archivedclients = -1;
        var archivedpostdischarges = -1;

        console.log("4447-10011 - action.payload.data = " );
        console.log( action.payload.data);

        dataEntry = (typeof(action.payload.data) !== "undefined" && action.payload.data !== null ) ? action.payload.data[0] : [] ;
        if (typeof(action.payload.data) !== "undefined" && action.payload.data !== null ) {                        
          console.log("4447-10012 - dataEntry = " );
          console.log( dataEntry);

            referrals = dataEntry.referrals;
            clients = dataEntry.clients;
            postdischarges = dataEntry.postdischarges;
            
            postdischarges = dataEntry.postdischarges;
            postdischarges90d = dataEntry.postdischarges90d;
            postdischarges180d = dataEntry.postdischarges180d;
            postdischarges12m = dataEntry.postdischarges12m;
            postdischarges24m = dataEntry.postdischarges24m;
            postdischarges36m = dataEntry.postdischarges36m;
    
            archivedreferrals = dataEntry.archivedreferrals;
            archivedclients = dataEntry.archivedclients;
            archivedpostdischarges = dataEntry.archivedpostdischarges;
        }

        state = {
            ...state,
            loadingList: false,
            loading: false,
            post: action.payload,
            error: '',
        
            reportTitle: "Dashboard Stats",

            referrals: referrals,
            clients: clients,
            postdischarges: postdischarges,
            
            postdischarges90d: postdischarges90d,
            postdischarges180d: postdischarges180d,
            postdischarges12m: postdischarges12m,
            postdischarges24m: postdischarges24m,
            postdischarges36m: postdischarges36m,
    
            archivedreferrals: archivedreferrals,
            archivedclients: archivedclients,
            archivedpostdischarges: archivedpostdischarges,
        };
        break;
    case GET_REPORTS_PROGRAMS_COUNTS_FULFILLED:
        console.log("4447-10031 - action.payload.data = " );
        console.log( action.payload.data);
        state = {
            ...state,
            loadingList: false,
            loading: false,
            error: '',
            reportTitle: "Programs Stats",
            reportData: (typeof(action.payload.data) !== "undefined" && action.payload.data !== null ) ? action.payload.data : [] ,
        };
        break;
    case GET_REPORTS_DASHBOARD_COUNTS_REJECTED:
    case GET_REPORTS_PROGRAMS_COUNTS_REJECTED:
        state = {
            ...state,
            loadingList: false,
            loading: false,
            errors: [action.payload.response],


            referrals: -1,
            clients: -1,
            postdischarges: -1,
            
            postdischarges90d: -1,
            postdischarges180d: -1,
            postdischarges12m: -1,
            postdischarges24m: -1,
            postdischarges36m: -1,
    
            archivedreferrals: -1,
            archivedclients: -1,
            archivedpostdischarges: -1,

            reportData: [],

        };
        break;

    default:
        return state;
  }

  return state;
};
export default reducerReportsGlobals;
